var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.00004C14 3.82599 13.9309 3.65907 13.8078 3.536C13.6847 3.41293 13.5178 3.34379 13.3438 3.34379H2.32757L4.16506 1.63755C4.22826 1.57895 4.27929 1.50847 4.31526 1.43015C4.35122 1.35182 4.3714 1.26718 4.37465 1.18105C4.3779 1.09493 4.36415 1.009 4.3342 0.928191C4.30424 0.847377 4.25866 0.773255 4.20006 0.710057C4.08171 0.582422 3.9175 0.507031 3.74356 0.500467C3.65743 0.497217 3.57151 0.510962 3.4907 0.540919C3.40988 0.570875 3.33576 0.616455 3.27256 0.675057L0.210083 3.51879C0.143822 3.58022 0.0909595 3.65467 0.0548086 3.73748C0.0186586 3.8203 0 3.90968 0 4.00004C0 4.09039 0.0186586 4.17978 0.0548086 4.26259C0.0909595 4.3454 0.143822 4.41985 0.210083 4.48128L3.27256 7.32502C3.4002 7.44337 3.56962 7.50617 3.74356 7.49961C3.9175 7.49304 4.08171 7.41765 4.20006 7.29002C4.31841 7.16238 4.38121 6.99296 4.37465 6.81902C4.36809 6.64508 4.29269 6.48087 4.16506 6.36252L2.32757 4.65628H13.3438C13.5178 4.65628 13.6847 4.58714 13.8078 4.46407C13.9309 4.341 14 4.17408 14 4.00004Z",
    fill: "#000B30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlack);
export default __webpack_public_path__ + "static/media/leftArrowBlack.f7526e4ba4419fb212a83655c0cc6d96.svg";
export { ForwardRef as ReactComponent };